<div class="dashboard-container" [class.compact-padding]="compactPadding">
  <header class="dashboard-header" *ngIf="pageTitle || subtitle">
    <span class="dashboard-header-icon" *ngIf="icon">
      <i [class]="icon"></i>
    </span>
    <div class="dashboard-header-text">
      <h1 class="dashboard-title" *ngIf="pageTitle">{{ pageTitle }}</h1>
      <p class="dashboard-subtitle" *ngIf="subtitle">{{ subtitle }}</p>
    </div>
  </header>

  <div class="dashboard-content">
    <!-- This is where the specific page content will be injected -->
    <ng-content></ng-content>
  </div>
</div>
